<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <div class="sidebar-brand">
      <div class="sidebar-brand-full text-right py-2">
        <img
          src="/img/logo/ayandehcement_new_logo.png"
          class="d-inline-block"
          width="200"
        />
      </div>
      <div class="sidebar-brand-narrow">
        <img
          src="/img/logo/ayandeh_256.png"
          class="d-inline-block"
          width="40"
        />
      </div>
    </div>
    <!--    <AppSidebarNav />-->
    <ul class="sidebar-nav">
      <li class="nav-item">
        <router-link :to="{ name: 'Dashboard' }" class="nav-link">
          <base-icon icon="dashboard" class="nav-icon" />
          داشبورد
        </router-link>
      </li>
      <!--    New Order    -->
      <li class="nav-item"
          v-if="has_permission([1, 2, 3, 7, 8, 9])"

      >
        <router-link :to="{ name: 'StoreNew' }" class="nav-link">
          <base-icon icon="add-circle" class="nav-icon" />
          ثبت سفارش
        </router-link>
      </li>
      <!--    Orders     -->
      <li class="nav-item"
          v-if="has_permission([1, 2, 3, 7, 8, 9])"
          :class="{
          show: in_array(
            ['Cards', 'CardMenu', 'CardList'],
            current_open,
          ),
        }"
      >
        <router-link :to="{ name: 'CardMenu' }" class="nav-link">
          <base-icon icon="note-stack" class="nav-icon" />
          سفارش ها
        </router-link>
      </li>
      <!--    Loads     -->
      <li class="nav-item"
          v-if="has_permission([1, 2, 3, 4, 5, 7, 8, 9])"
          :class="{ show: in_array(['Orders', 'OrderList'], current_open) }">
        <router-link :to="{ name: 'OrderList' }" class="nav-link">
          <base-icon icon="local-shipping" class="nav-icon" />
          بارها
        </router-link>
      </li>
      <!--    Payment     -->
      <template v-if="has_permission([1, 2, 3, 6, 7, 8, 9])"
                :class="{
          show: in_array(
            ['Payment', 'NewPayment', 'PaymentList'],
            current_open,
          ),
        }">
        <li class="nav-item">
          <router-link :to="{ name: 'NewPayment' }" class="nav-link">
            <base-icon icon="add-card" class="nav-icon" />
            ثبت پرداخت
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'PaymentList' }" class="nav-link">
            <base-icon icon="credit-card" class="nav-icon" />
            لیست پرداخت
          </router-link>
        </li>
      </template>
      <!--    Turnover / گردش حساب     -->
      <li class="nav-item" v-if="has_permission([1, 2, 3, 4, 6, 7, 8, 9])">
        <router-link :to="{ name: 'Gardesh' }" class="nav-link">
          <base-icon icon="swap-horizontal-circle" class="nav-icon" />
          گردش حساب
        </router-link>
      </li>
      <!--    Paymentable     -->
      <li class="nav-item" >
        <router-link :to="{ name: 'NewPaymentAbleList' }" class="nav-link">
          <base-icon icon="credit-card-clock" class="nav-icon" />
          پرداختنی
        </router-link>
      </li>
      <!--    Sanads     -->
      <li class="nav-item" v-if="has_permission([1, 2, 3, 9])">
        <router-link :to="{ name: 'SanadMenu' }" class="nav-link">
          <base-icon icon="quick-reference-all" class="nav-icon" />
          اسناد حسابداری
          <span
            class="badge bg-danger ms-auto"
            v-text="$store.state.count_not_verify_sanad"
            v-if="
              $store.state.count_not_verify_sanad > 0 &&
              $store.state.loading_get_sanad_data == false
            "
          ></span>
        </router-link>
      </li>
      <!--    Facroty And Products / کارخانه و محصولات     -->
      <li class="nav-item" v-if="has_permission([1, 2, 3])">
        <router-link :to="{ name: 'FactoryList' }" class="nav-link">
          <base-icon icon="factory" class="nav-icon" />
          کارخانه و محصولات
        </router-link>
      </li>
      <!-- finanical year management / مدیریت سال مالی -->
      <li class="nav-item" v-if="has_permission([1, 2, 3])">
        <router-link :to="{ name: 'FiscalYear' }" class="nav-link">
          <base-icon icon="event" class="nav-icon" />
          مدیریت سال مالی
        </router-link>
      </li>
    </ul>
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { mapActions, useStore } from 'vuex'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'
import BaseIcon from "@/components/base/BaseIcon.vue";
// import { AppSidebarNav } from '@/components/AppSidebarNav'
export default {
  name: 'AppSidebar',
  components: {BaseIcon},
  data() {
    return {
      current_open: '',
    }
  },
  mounted() {
    if (
      this.getCookie('snd_fiscal_year') &&
      this.getCookie('snd_fiscal_year')?.length > 10
    ) {
      this.set_current_or_cookie_or_query_fiscal_year()
    }
    this.current_open = this.$route.name
  },
  // components: { AppSidebarNav },
  setup() {
    const store = useStore()
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
  methods: {
    ...mapActions(['get_sanad_data']),
    toggleNav(route_name) {
      if (this.current_open == route_name) {
        this.current_open = ''
      } else {
        this.current_open = route_name
      }
    },
    in_array(array, niddle) {
      var is = array.filter((x) => x == niddle).length
      if (is > 0) return true
      return false
    },
  },
  watch: {
    fiscal_year_snd(newValue) {
      this.get_sanad_data(newValue)
    },
  },
}
</script>
